import styled from 'styled-components';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  width: 100%;
  background: linear-gradient(135deg, rgba(23,191,221,1) 0%,rgba(18,175,225,1) 100%);
  height:100%;
`;

export const Title = styled.label`
  color: #fff;
  font: normal 40px/54px "AvenirNextLTW01-Regular";
  margin: 20px 0 20px;
  text-align: center;
  font-family: "Avenir Next LT W01 Demi";
`;

export const DescriptionContainer = styled.div`
  align-self: center;
  margin: 20px 0;
  text-align: center;
`;

export const Description = styled.label`
  width: 80%;
  margin-top: 3px;
  color: #fff;
  font: normal 16px/24px "AvenirNextLTW01-Regular";
`;
